import { render, staticRenderFns } from "./service-uploads.vue?vue&type=template&id=28ff8286&scoped=true"
import script from "./service-uploads.vue?vue&type=script&lang=js"
export * from "./service-uploads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ff8286",
  null
  
)

export default component.exports